import React from 'react';
import ServiceCardItem from '../service-cards/ServiceCardItem';
import './ServicesCards.css';

function ServicesCard() {
  return (
    <section className="services-section">
      <div className="services-section-container">
        <h2 className="services-title">Our Services</h2>
        <div className="services-cards-container">
          <ul className="service-cards">

            <ServiceCardItem
              imagesrc='/images/electric_wire.webp'
              iconsrc='/images/icon-rewire.jpg'
              title="Electrical & Fire Fighting"
              text="We handle complete electrical installations along with fire fighting systems to ensure safety, compliance, and efficient operation of your property."
            />

            <ServiceCardItem
              imagesrc='/images/plumbing.webp'
              iconsrc='/images/icon-inspection.jpg'
              title="Plumbing and Sanitary Works"
              text="We provide reliable plumbing and sanitary solutions including water supply systems, drainage, and installation of fixtures for residential and commercial use."
            />

            <ServiceCardItem
              imagesrc='/images/fire_detect.webp'
              iconsrc='/images/icon-outdoor-lighting.jpg'
              title="Fire Detection/Protection Systems"
              text="Installation of advanced fire detection and protection systems such as alarms, smoke detectors, and safety mechanisms to protect lives and assets."
            />

            <ServiceCardItem
              imagesrc='/images/dc.jpg'
              iconsrc='/images/icon-rewire.jpg'
              title="DG Exhaust Piping"
              text="We offer DG exhaust piping solutions with proper insulation and ventilation to ensure safe emission flow and optimal generator performance."
            />

            <ServiceCardItem
              imagesrc='/images/cctv.jpeg'
              iconsrc='/images/icon-inspection.jpg'
              title="CCTV"
              text="Secure your premises with CCTV surveillance systems offering real-time monitoring, recording, and remote access for enhanced security."
            />

            <ServiceCardItem
              imagesrc='/images/network.jpg'
              iconsrc='/images/icon-outdoor-lighting.jpg'
              title="Networking System"
              text="We design and install structured networking systems including LAN setup, cabling, and infrastructure for seamless connectivity."
            />

          </ul>
        </div>
      </div>
    </section>
  );
}

export default ServicesCard;